module.exports = __webpack_public_path__ + "static/iamailogo-e043ecba7fab72e52bfa336477de732b.svg";